import React, { useEffect, useState } from 'react'
import Navigation from '../components/Navigation';
import NavigationRanking from '../components/NavigationRanking';
import { Award } from 'lucide-react';
import Leaderboard from '../components/Leaderboard';
import { useLeaderboard, useNewsRankingBoard } from '../hooks/useLeaderboard';
import { LeaderboardType } from '../types';

const Ranking = () => {
    const [activeTab, setActiveTab] = useState<LeaderboardType>('weekly');
    const [category, setCategory] = useState<'general' | 'news'>('general');
  
    const { users: weeklyUsers, loading: weeklyLoading, error: weeklyError } = 
      useLeaderboard('weekly');
    const { users: monthlyUsers, loading: monthlyLoading, error: monthlyError } = 
      useLeaderboard('monthly');
    const { users: allTimeUsers, loading: allTimeLoading, error: allTimeError } = 
      useLeaderboard('allTime');

    const { users: newsWeekly, loading: nwLoading, error: nwError } = useNewsRankingBoard('weekly');
    const { users: newsMonthly, loading: nmLoading, error: nmError } = useNewsRankingBoard('monthly');
    const { users: newsAllTime, loading: naLoading, error: naError } = useNewsRankingBoard('allTime');
    
    const getActiveLeaderboard = () => {
      if (category === 'news') {
        switch (activeTab) {
          case 'weekly': return <Leaderboard title="News - Weekly" type="weekly" users={newsWeekly} loading={nwLoading} error={nwError} />;
          case 'monthly': return <Leaderboard title="News - Monthly" type="monthly" users={newsMonthly} loading={nmLoading} error={nmError} />;
          case 'allTime': return <Leaderboard title="News - All-Time" type="allTime" users={newsAllTime} loading={naLoading} error={naError} />;
          default: return null;
        }
      }

      switch (activeTab) {
        case 'weekly':
          return (
            <Leaderboard
              title="Weekly Rankings"
              type="weekly"
              users={weeklyUsers}
              loading={weeklyLoading}
              error={weeklyError}
            />
          );
        case 'monthly':
          return (
            <Leaderboard
              title="Monthly Rankings"
              type="monthly"
              users={monthlyUsers}
              loading={monthlyLoading}
              error={monthlyError}
            />
          );
        case 'allTime':
          return (
            <Leaderboard
              title="All-Time Rankings"
              type="allTime"
              users={allTimeUsers}
              loading={allTimeLoading}
              error={allTimeError}
            />
          );
        default:
          return null;
      }
    };
  
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-950 to-slate-900 text-white">
        <div className="container mx-auto px-4 py-12">
          <header className="text-center mb-12">
            <div className="flex items-center justify-center mb-4">
              <Award className="w-10 h-10 text-amber-400 mr-3" />
              <h1 className="text-3xl md:text-4xl font-bold text-white">
                Champions Board
              </h1>
            </div>
            <p className="text-slate-400 max-w-xl mx-auto">
              Aprenda, some pontos, compita com os seus amigos e suba no ranking!
            </p>
          </header>
  
          <div className="max-w-2xl mx-auto">
            <div className="flex justify-center gap-4 mb-6">
              <button 
                onClick={() => setCategory('general')} 
                className={`px-6 py-2 rounded-full font-bold transition-all ${category === 'general' ? 'bg-amber-400 text-slate-900' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}
              >
                General
              </button>
              <button 
                onClick={() => setCategory('news')} 
                className={`px-6 py-2 rounded-full font-bold transition-all ${category === 'news' ? 'bg-purple-500 text-white' : 'bg-slate-800 text-slate-300 hover:bg-slate-700'}`}
              >
                Daily News
              </button>
            </div>
            
            <NavigationRanking activeTab={activeTab} onTabChange={setActiveTab} />
            
            <div className="bg-slate-900/80 backdrop-blur-sm rounded-xl p-6 shadow-xl border border-slate-800">
              {getActiveLeaderboard()}
            </div>
  
            <footer className="mt-12 text-center text-slate-500 text-sm">
              <p>
                Weekly scores reset every Monday at 00:00, and monthly scores reset on the 1st of each month.
              </p>
            </footer>
          </div>
        </div>
      </div>
    );
  }

export default Ranking